@if (userMustProvideInstitution) {
<nz-form-item>
  <nz-form-label translate>payment.beneficiaryBankIdentifier.label</nz-form-label>
  <nz-form-control>
    <app-institution-autocomplete
      nzSize="large"
      [maxlength]="config.beneficiaryBankIdentifierMaxLength"
      [placeholder]="'payment.beneficiaryBankIdentifier.placeholder' | translate: locale.language"
      (institutionSelected)="onInstitutionSelect($event)"
      [formControl]="beneficiaryBankIdentifierControl"
      data-cy="payment-beneficiary-bank-identifier"
    ></app-institution-autocomplete>
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label translate>payment.beneficiaryBankName.label</nz-form-label>
  <nz-form-control>
    <input
      nz-input
      nzSize="large"
      type="text"
      [maxlength]="config.beneficiaryBankNameMaxLength"
      [placeholder]="'payment.beneficiaryBankName.placeholder' | translate: locale.language"
      [formControl]="beneficiaryBankNameControl"
      data-cy="payment-beneficiary-bank-name"
    />
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label translate>payment.receiverInfo.beneficiaryBankCountry.label</nz-form-label>
  <nz-form-control>
    <nz-select
      nzSize="large"
      nzShowSearch
      l10n-placeholder
      [nzPlaceHolder]="'payment.receiverInfo.beneficiaryBankCountry.placeholder' | translate: locale.language"
      [formControl]="beneficiaryBankCountryControl"
      data-cy="payment-beneficiary-bank-country-select"
    >
      @for (country of countries$ | async; track country.id) {
      <nz-option [nzLabel]="country.label" [nzValue]="country.id"></nz-option>
      }
    </nz-select>
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label translate>payment.beneficiaryBankAddress.label</nz-form-label>
  <nz-form-control>
    <input
      nz-input
      nzSize="large"
      type="text"
      [maxlength]="config.beneficiaryBankAddressMaxLength"
      [placeholder]="'payment.beneficiaryBankAddress.placeholder' | translate: locale.language"
      [formControl]="beneficiaryBankAddressControl"
      data-cy="payment-beneficiary-bank-address"
    />
  </nz-form-control>
</nz-form-item>
}
